module.exports = __webpack_public_path__ + "static/media/CheckAB.d9ae5f55.png";